import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { provideRouter, withEnabledBlockingInitialNavigation, RouterModule } from '@angular/router';
import { CustomerSelectionModule } from '@next/arable-lib/customer-selection';
import { CoreEffects } from '@next/core-lib';
import { provideAgrAdvisorRelationshipsSelector } from '@next/core-lib/advisor-relationships-selector';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { IgnoreStatusOfflinePatterns } from '@next/core-lib/components';
import { provideAgrElasticApi } from '@next/core-lib/elastic';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideStore, provideState } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { ManureSpaceCustomerSelectionCustomConfigComponent } from './customer-selection-custom-config/customer-selection-custom-config.component';
import { FertilizationLegalStandardsModule } from './fertilization-legal-standards/fertilization-legal-standards.module';
import { FertilizersModule } from './fertilizers/fertilizers.module';
import { FieldsModule } from './fields/fields.module';
import { SharedModule } from './shared/shared.module';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent, ManureSpaceCustomerSelectionCustomConfigComponent],
  imports: [
    RouterModule,
    SharedModule,
    FertilizersModule,
    FertilizationLegalStandardsModule,
    FieldsModule,
    MatIconModule,
    AgrWrapperSiteSidenavModule,
    CustomerSelectionModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrAdvisorRelationshipsSelector(),
    provideAgrElasticApi(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),

    provideEffects(),
    provideState('app', appReducer),
    provideEffects(AppEffects),
    {
      provide: IgnoreStatusOfflinePatterns,
      useValue: ['/arable-service/organisation/customerprogress'],
      multi: true,
    },
  ],
})
export class AppModule {}
